import { useSyncExternalStore } from 'react';

// antd's breakpoints (sm 576, md 768, lg 992), read synchronously so the first render already has the right layout.
function useMedia(query: string) {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window.matchMedia !== 'function') return () => {};
      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => media.removeEventListener('change', onChange);
    },
    () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
    () => false,
  );
}

export function useResponsive() {
  const isMobile = useMedia('(max-width: 767.98px)');
  const isCompact = useMedia('(max-width: 991.98px)');
  /** Phones: < md. Compact (phones + tablets): < lg, where the side nav becomes a drawer. */
  return { isMobile, isCompact, isDesktop: !isCompact };
}
